/**
 * Returns true if the given URL is served from an imgix domain.
 * Only imgix URLs should be passed to the ImgixImage component —
 * non-imgix URLs won't benefit from imgix transformations.
 */
export const isImgixUrl = (src: string): boolean => {
  try {
    return new URL(src).hostname.endsWith('.imgix.net');
  } catch {
    return false;
  }
};
